import { cn } from "../lib/utils.js";
import { jsx } from "react/jsx-runtime";
import * as PopoverPrimitive from "@radix-ui/react-popover";
//#region src/components/popover.tsx
function Popover({ ...props }) {
	return /* @__PURE__ */ jsx(PopoverPrimitive.Root, {
		"data-slot": "popover",
		...props
	});
}
function PopoverTrigger({ ...props }) {
	return /* @__PURE__ */ jsx(PopoverPrimitive.Trigger, {
		"data-slot": "popover-trigger",
		...props
	});
}
function PopoverContent({ className, align = "center", sideOffset = 4, ...props }) {
	return /* @__PURE__ */ jsx(PopoverPrimitive.Portal, { children: /* @__PURE__ */ jsx(PopoverPrimitive.Content, {
		"data-slot": "popover-content",
		align,
		sideOffset,
		className: cn("tw tw:bg-popover tw:text-popover-foreground tw:data-[state=open]:animate-in tw:data-[state=closed]:animate-out tw:data-[state=closed]:fade-out-0 tw:data-[state=open]:fade-in-0 tw:data-[state=closed]:zoom-out-95 tw:data-[state=open]:zoom-in-95 tw:data-[side=bottom]:slide-in-from-top-2 tw:data-[side=left]:slide-in-from-right-2 tw:data-[side=right]:slide-in-from-left-2 tw:data-[side=top]:slide-in-from-bottom-2 tw:z-50 tw:w-72 tw:origin-(--radix-popover-content-transform-origin) tw:rounded-md tw:border tw:p-4 tw:shadow-md tw:outline-hidden tw:border-border", className),
		...props
	}) });
}
function PopoverAnchor({ ...props }) {
	return /* @__PURE__ */ jsx(PopoverPrimitive.Anchor, {
		"data-slot": "popover-anchor",
		...props
	});
}
//#endregion
export { Popover, PopoverAnchor, PopoverContent, PopoverTrigger };

//# sourceMappingURL=popover.js.map